import { isDevMode, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from '../shared/components/loader/loader.component';
import { ToolLoaderComponent } from '../shared/components/tool-loader/tool-loader.component';
import { ValidationErrorComponent } from '../wellbore-inputs/components/well-configuration/components/validation-error.component';
import { NumberFormatDialogComponent } from '../shared/components/ng-table-grid/number-format-dialog.component';
import { CompareDialogComponent } from '../shared/components/ng-table-grid/compare-dialog.component';
import { NgTableResultsComponent } from '../shared/components/ng-table-results/ng-table-results.component';
import { AllowedRangeComponent } from '../shared/components/allowed-range/allowed-range.component';
import { XyLinePlotComponent } from '../core/components/xy-line-plot/xy-line-plot.component';
import { XyLinePlotAxisEditorComponent } from '../core/components/xy-line-plot/xy-line-plot-axis-editor.component';
import { CatalogMetadataIconComponent } from '../shared/components/catalog-metadata-icon/catalog-metadata-icon.component';
import { CatalogItemPreviewComponent } from '../shared/components/catalog-item-preview/catalog-item-preview.component';
import { ValidatedNumberInputComponent } from '../shared/components/validated-number-input/validated-number-input.component';
import { UnitsGridInputComponent } from '../shared/components/units-grid-input/units-grid-input.component';
import { UnitsSelectInputComponent } from '../shared/components/units-select-input/units-select-input.component';
import { SaveFeedbackComponent } from '../shared/components/save-feedback/save-feedback.component';

import { RangeSelectionDirective } from '../shared/helpers/range-select.directive';
import { AutoTableHeightDirective } from '../shared/helpers/auto-table-height.directive';
import { SanitizeHtmlPipe } from '../shared/pipes/sanitize-html.pipe';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridstackModule } from 'gridstack/dist/angular';
import { DynamicModule } from 'ng-dynamic-component';
import { PlotlyViaWindowModule } from 'angular-plotly.js';
import { PrimeNGModule } from '../modules/primeng.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { devTools } from '@ngneat/elf-devtools';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { DesignPresenceModalComponent } from '../core/components/design-presence/design-presence-modal';
import { ScopeFilterComponent } from '../catalogs/shared/scope-filter.component';

if (isDevMode()) {
  devTools();
}

const sharedComponents = [
  DesignPresenceModalComponent,
  LoaderComponent,
  ToolLoaderComponent,
  ValidationErrorComponent,
  NumberFormatDialogComponent,
  CompareDialogComponent,
  NgTableResultsComponent,
  AllowedRangeComponent,
  XyLinePlotComponent,
  XyLinePlotAxisEditorComponent,
  CatalogMetadataIconComponent,
  CatalogItemPreviewComponent,
  ValidatedNumberInputComponent,
  UnitsGridInputComponent,
  SaveFeedbackComponent,
  RangeSelectionDirective,
  AutoTableHeightDirective,
  SanitizeHtmlPipe
];

@NgModule({
  declarations: [
    ...sharedComponents
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    GridstackModule,
    PlotlyViaWindowModule,
    PrimeNGModule,
    DynamicModule,
    DynamicDialogModule,
    AngularSvgIconModule,
    UnitsSelectInputComponent,
    ScopeFilterComponent  // Import standalone component
  ],
  exports: [
    ...sharedComponents,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    GridstackModule,
    PlotlyViaWindowModule,
    PrimeNGModule,
    DynamicModule,
    UnitsSelectInputComponent,
    ScopeFilterComponent  // Export standalone component
  ]
})
export class SharedModule { }
